import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';

export const numCastNodeSpec: NodeSpec<NodeCfg<'numCast'>> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: {}, id: getUID(), kind: 'numCast', disabled: false }),
    controls: () => ({}),
    inputs: () => ({ input: { socket: 'varValue', label: 'Input' } }),
    kindLabel: 'Number Value Cast',
    nodeCategory: 'number',
    outputs: () => ({ output: { socket: 'number', label: 'Output' } }),
    validator: () => true,
};
